import type { FormProviderProps } from '@/schemas/components/molecules/formSchema';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ContactForm } from './ContactForm';
import { GatedContentForm } from './GatedContentForm';

const queryClient = new QueryClient();

export const FormProvider = ({
  isGatedContent,
  ...props
}: FormProviderProps) => (
  <QueryClientProvider client={queryClient}>
    {isGatedContent ?
      <GatedContentForm {...props} />
    : <ContactForm {...props} />}
  </QueryClientProvider>
);
